import { INDEX_DETAILS, INDEX_DETAILS_ERROR, INDEX_DETAILS_HIDE_ERROR, INDEX_DETAILS_START_LOADER, INDEX_DETAILS_STOP_LOADER, STREAM_INDEX_DETAILS, } from "../interface/IIndexDetails";
import { updatedIndexList } from "@domains/features/PostLogin/utils/streamingUpdate";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const IndexDetails = (state = initState, action) => {
    switch (action.type) {
        case INDEX_DETAILS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case STREAM_INDEX_DETAILS: {
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { userIndices: Object.assign(Object.assign({}, state.data.userIndices), { bull: updatedIndexList(action.payload.streamData, state.data.userIndices.bull) }) }) });
        }
        case INDEX_DETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case INDEX_DETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case INDEX_DETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case INDEX_DETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default IndexDetails;
